<div class="cookies-banner" *ngIf="visible">
  <div class="cookies-banner__content">
    <div class="cookies-banner__copy">
      <h2>AVISO SOBRE COOKIES</h2>
      <p>
        Utilizamos cookies propias necesarias para el funcionamiento seguro de la plataforma
        (inicio de sesion, mantenimiento de sesion y seguridad) y cookies de terceros para el
        analisis del uso de la plataforma y la mejora del rendimiento del software. Puedes aceptar
        todas las cookies, rechazar las no necesarias o configurar tus preferencias.
      </p>

      <button class="cookies-banner__link" type="button" (click)="openPolicy()" *ngIf="policy">
        Mas informacion en nuestra Politica de Cookies.
      </button>
    </div>

    <div class="cookies-banner__actions">
      <button mat-stroked-button type="button" (click)="acceptAll()" [disabled]="loading || saving">
        ACEPTAR COOKIES
      </button>
      <button mat-stroked-button type="button" (click)="rejectNonEssential()" [disabled]="loading || saving">
        RECHAZAR COOKIES
      </button>
      <button mat-stroked-button type="button" (click)="openConfiguration()" [disabled]="loading || saving">
        CONFIGURAR
      </button>
    </div>
  </div>

  <div class="cookies-banner__status" *ngIf="loading">
    <mat-spinner diameter="22"></mat-spinner>
    <span>VALIDANDO CONSENTIMIENTO...</span>
  </div>

  <div class="cookies-banner__status cookies-banner__status--error" *ngIf="!loading && !policy">
    <span>NO SE PUDO CARGAR LA POLITICA DE COOKIES. LAS ANALITICAS SIGUEN BLOQUEADAS.</span>
    <button mat-button type="button" (click)="retry()">REINTENTAR</button>
  </div>
</div>

<div class="cookies-modal-backdrop" *ngIf="showConfigModal">
  <section class="cookies-panel cookies-panel--config" aria-modal="true" role="dialog">
    <button class="cookies-panel__close" type="button" (click)="closeConfiguration()" [disabled]="saving">
      <mat-icon>close</mat-icon>
    </button>

    <div class="cookies-panel__head">
      <h3>CONFIGURAR COOKIES</h3>
      <p>Las cookies tecnicas permanecen activas. Solo puedes modificar las cookies analiticas.</p>
    </div>

    <div class="cookies-panel__body">
      <article class="cookies-option cookies-option--locked">
        <div class="cookies-option__copy">
          <div class="cookies-option__title">Cookies tecnicas</div>
          <div class="cookies-option__text">Necesarias para seguridad, sesion y funcionamiento basico del sitio.</div>
        </div>

        <div class="cookies-option__control cookies-option__control--locked">
          <mat-slide-toggle [checked]="true" [disabled]="true">Siempre activas</mat-slide-toggle>
        </div>
      </article>

      <article class="cookies-option">
        <div class="cookies-option__copy">
          <div class="cookies-option__title">Cookies analiticas</div>
          <div class="cookies-option__text">Nos ayudan a medir uso del sitio sin afectar funciones esenciales.</div>
        </div>

        <div class="cookies-option__control">
          <mat-slide-toggle
            [checked]="categories.analiticas"
            (change)="categories.analiticas = $event.checked"
            [disabled]="saving"
          >
            {{ categories.analiticas ? 'Activas' : 'Bloqueadas' }}
          </mat-slide-toggle>
        </div>
      </article>

      <button class="cookies-panel__link" type="button" (click)="openPolicy()" *ngIf="policy">
        Ver Politica de Cookies completa
      </button>
    </div>

    <div class="cookies-panel__actions">
      <button mat-button type="button" (click)="closeConfiguration()" [disabled]="saving">CANCELAR</button>
      <button mat-flat-button color="primary" type="button" (click)="saveConfiguration()" [disabled]="saving">
        GUARDAR CONFIGURACION
      </button>
    </div>
  </section>
</div>

<div class="cookies-modal-backdrop" *ngIf="showPolicyModal">
  <section class="cookies-panel cookies-panel--legal" aria-modal="true" role="dialog">
    <button class="cookies-panel__close" type="button" (click)="closePolicy()">
      <mat-icon>close</mat-icon>
    </button>

    <div class="cookies-panel__head cookies-panel__head--legal">
      <h3>{{ policy?.titulo || 'POLITICA DE COOKIES' }}</h3>
      <p *ngIf="policy?.edicion">Version {{ policy?.edicion }}</p>
    </div>

    <div class="cookies-panel__legal" [innerHTML]="policy?.contenido"></div>

    <div class="cookies-panel__actions">
      <button mat-flat-button color="primary" type="button" (click)="closePolicy()">CERRAR</button>
    </div>
  </section>
</div>
